<template>
  <div>
    <layout-header ref="layoutheader" v-if="!$route.meta.noheader" />
    <!-- noBottom 没有底部导航栏
           header1  17.5rem的顶部
           header2  5rem的顶部
           header3  13rem的顶部
           header5  gamedetail
    -->
    <div
      :class="{'layout-main':true,'noBottom': $route.meta.noBottom,'header1': $route.meta.header1,'header2': $route.meta.header2,'header3': $route.meta.header3,'header4': $route.meta.header4,'website1': $route.meta.website1,'website2': $route.meta.website2,'white': $route.meta.white,'pr0':$route.meta.pr0,'pl0':$route.meta.pl0,'noheader': $route.meta.noheader,'header_index': $route.name == 'index','header5':$route.meta.header5,'header6':$route.meta.logoff,'header7':$route.name == 'home'&&home_active == 2,'usercenter':$route.meta.usercenter,'accgoods-main':$route.meta.accgoods}">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="$route.meta.unPullRefresh">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :showJc="showJc" @changeJc="changeJc"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :showJc="showJc" @changeJc="changeJc"></router-view>
      </van-pull-refresh>
    </div>
    <van-tabbar v-model="active" route class="footer" active-color="var(--theme)" inactive-color="#999"
      v-if="!$route.meta.noBottom">
      <van-tabbar-item :to="(indexfrom == ''||indexfrom == 'null'||indexfrom == null)?'/index':'/index?from='+indexfrom"
        class="index_tab">
        <template #icon>

        </template>
        首页
      </van-tabbar-item>

      <!-- <van-tabbar-item to="/dajin" class="dajin_tab">
        <template #icon>

        </template>
        打金
      </van-tabbar-item>
      <van-tabbar-item class="footer_sell" to="/sell" v-if="isLogin">
        <template #icon>
          <van-icon name="plus" />
        </template>
        出售
      </van-tabbar-item>
      <van-tabbar-item class="footer_sell" v-else @click="gotoSell">
        <template #icon>
          <van-icon name="plus" />
        </template>
        出售
      </van-tabbar-item>
      <van-tabbar-item to="/home" class="home_tab">
        <template #icon>

        </template>
        购买
      </van-tabbar-item> -->
      <van-tabbar-item to="/market" class="footer_sell">
        <template #icon>

        </template>
        交易市场
      </van-tabbar-item>
      <van-tabbar-item to="/user/center" class="my_tab">
        <template #icon>

        </template>
        我的
      </van-tabbar-item>
    </van-tabbar>

    <div class="jc" v-if="showJc">
      <!-- 1 -->
      <div class="step step1" v-if="step == 1&& $route.name == 'index'">
        <div class="cont">
          <div>
            <p>想买？想卖？</p>
            <p>装备、道具、角色都在这里！</p>
          </div>
          <div class="tip_round"></div>
        </div>
        <div class="img">
          交易市场
        </div>
        <div class="next_button" @click="next1">下一步</div>
      </div>
      <!-- 2 -->
      <div class="step step2" v-else-if="step == 2&& $route.name == 'market'&&step2_info.top">
        <div class="game_box" :style="{'margin-top': step2_info.top + 'px'}">
          <van-image class="icon" :src="step2_info.icon" />
          <div class="info">
            <p class="name">{{ step2_info.app_name }}</p>
            <p class="num">
              <span>共上架{{step2_info.goods_cnt}}件商品</span>
              <span>已售<i>{{step2_info.trade_cnt}}</i>件</span>
            </p>
          </div>
          <div class="rz">
            <img class="rz_icon" src="../../assets/version_1.3.0/market/rz.png" alt="">
            <span v-if="step2_info.prop_trade == 1">道具</span>
            <span :class="{'bl': step2_info.prop_trade == 1}" v-if="step2_info.role_trade == 1">角色</span>
          </div>
        </div>
        <div class="cont">
          <div class="tip_round"></div>
          <div>选个您中意的游戏吧</div>
        </div>
        <div class="next_button" @click="next2">下一步</div>
      </div>
      <!-- 3 -->
      <div class="step step3" v-else-if="step == 3 && $route.name == 'home'">

        <div class="next_button" @click="next3">我知道了</div>
        <div class="cont">
          <div>［出售］搬到［交易市场］啦！</div>
          <div class="tip_round"></div>
        </div>
        <div class="img"></div>
      </div>
    </div>

    <!-- <div v-show="!isApp&&qrurl != ''&&($route.name == 'index' || $route.name == 'user.withdraw')">
      <transition :enter-active-class="'animate__animated animate__delay-half1s ' + 'animate__slideInRight'"
        :leave-active-class="'animate__animated animate__faster ' + 'animate__slideOutRight'">
        <div class="qr_close" v-show="!showqr" @click="showqr = true">
          <van-icon name="arrow-left" class="arrow" color="var(--theme)" />
        </div>
      </transition>
      <transition :enter-active-class="'animate__animated ' + 'animate__slideInRight'"
        :leave-active-class="'animate__animated ' + 'animate__slideOutRight'">
        <div class="qr_open" v-show="showqr">
          <van-icon name="arrow" class="arrow" color="var(--theme)" @click="showqr = false"></van-icon>
          <vue-qr class="qrcode" :logoSrc="imageUrl" text="https://ldy.juhero.cn/ldy/jypt/index.html" :size="200" :margin="15" :logoScale="0.2"></vue-qr>
          <a :href="qrurl" target="_blank">点击下载APP</a>
        </div>
      </transition>
    </div> -->
  </div>

</template>

<script>
  import {
    debounce
  } from 'riku-verycloud'
  // import QRCode from "qrcodejs2";
  import vueQr from "vue-qr";
  export default {
    name: "layout-main",
    data() {
      return {
        active: "",
        isLoading: false,
        isbind: false,
        role: [],
        list: ['agreement', 'policy', 'children', 'thirdparty'],
        showJc: false,
        step: 1,
        showqr: false,
        indexfrom: '',
        step2_info: {},
        imageUrl: require('../../assets/qrcode_img.png')
      };
    },
    components: {
      vueQr
    },
    computed: {
      route_gameId() {
        return {
          route: this.$route,
          gameId: this.$route.query.id || ''
        }
      },
      isAndroid() {
        var u = navigator.userAgent;
        if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
          return true
        } else {
          return false
        }
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
      isApp() {
        return this.$store.state.isApp
      },
      isiOS() {
        var u = navigator.userAgent;
        if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          return true
        } else {
          return false
        }
      },
      qrurl() {
        if (this.isiOS) {
          return ''
        } else {
          return 'https://ldy.juhero.cn/ldy/jypt/index.html'
        }
      },
      //道具or角色 市场
      home_active() {
        return this.$store.state.home_active
      }
    },
    created() {
      var that = this;
      // web端向原生端请求获取设备信息
      if (this.isAndroid) {
        try {
          window.android.requestDeviceInfoWebToNative();
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          window.webkit.messageHandlers.requestDeviceInfoWebToNative.postMessage(null);
        } catch (error) {
          console.log(error);
        }
      }

      // 原生端发送设备信息到web端
      window["getDeviceInfoNativeToWeb"] = function (data) {
        if (data) {
          that.$store.commit('watchApp', true)
        }
        that.$store.dispatch("setAppInfo", {
          appdeviceinfo: data,
        });
        // web端请求原生端是否需要展示新手引导
        if (that.isAndroid) {
          try {
            window.android.checkNeedGuideWebToNative();
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            window.webkit.messageHandlers.checkNeedGuideWebToNative.postMessage(null);
          } catch (error) {
            console.log(error);
          }
        }
      }
      // 原生端通知web端是否需要展示新手引导 "needGuide":1,//1:展示 0：不展示
      window["getGuideStatusNativeToWeb"] = function (data) {
        const obj = JSON.parse(data);
        if (obj.needGuide == 1) {
          that.showJc = true;
        }
      };

    },
    mounted() {
      // this.creatQrCode(this.qrurl)
      this.indexfrom = window.localStorage.getItem('indexfrom')
    },
    methods: {
      creatQrCode(url) {
        this.$refs.qrcode.innerHTML = ''
        new QRCode(this.$refs.qrcode, {
          text: url, // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,

        });
      },
      // 点击出售
      gotoSell() {
        if (this.isLogin) {
          this.$router.push({
            name: 'sell'
          })
        } else {
          this.$filterPop({
            type: "login",
            direction: 'up',
            onSuccess: () => {
              this.$router.push({
                name: 'sell'
              })
            }
          });
        }
      },
      onRefresh() {
        var that = this;
        setTimeout(() => {
          window.location.reload();
          that.isLoading = false;
        }, 1000);
      },
      //得到参数
      changeJc(e) {
        this.step2_info = e
      },
      next1() {
        this.$router.push({
          name: 'market'
        })
        setTimeout(() => {
          this.step = 2
        }, 1000)
      },
      next2() {
        this.step = 3
        this.$store.commit('resetServer')
        this.$store.commit('resetHomeServer')
        this.$store.commit('setGameInfo', {
            name:this.step2_info.app_name,
            icon:this.step2_info.icon,
            id:this.step2_info.id
        })
                
        this.$store.commit('setCt','')
        this.$store.commit('setCi','')
        this.$store.commit('setCt2','')
        this.$store.commit('setCi2','')
        //道具市场 角色市场判断
        this.$store.commit('setHome',{prop_trade:this.step2_info.prop_trade,role_trade:this.step2_info.role_trade})
        if(this.step2_info.prop_trade == 0) {
            this.$store.commit('changeHome',2)
        }else {
            this.$store.commit('changeHome',1)
        }
        //角色市场 筛选全部重置
        this.$store.commit('resetAccPx')
        this.$router.push({name: 'home',
          query: {
            id: this.step2_info.id
          }
        })
      },
      next3() {
        this.showJc = false
        this.$router.push({
          name: 'index'
        })
      }
      // //检查用户是否绑定账号
      // checkBindAccount:debounce(function(app_id) {
      //   this.$Ajax('user-info/check-bind-account', {
      //     app_id
      //   }).then(rs => {
      //     if (rs.code == 200) {
      //       this.isbind = rs.data.is_bind
      //       if (this.isbind) {
      //         this.getUserRoleList(app_id)
      //       }else {
      //         this.role = []
      //         this.$store.commit('setBindrole', {
      //           role_id: '',
      //           role_name: '',
      //           server_id: '',
      //           server_name: ''
      //         })
      //       }
      //     } else {
      //       this.role = []
      //       this.$store.commit('setBindrole', {
      //         role_id: '',
      //         role_name: '',
      //         server_id: '',
      //         server_name: ''
      //       })
      //       this.isbind = false
      //     }
      //   })
      // }),
      // //获取角色列表
      // getUserRoleList(app_id) {
      //   this.$Ajax('user-info/user-role-list', {
      //     app_id
      //   }).then(rs => {
      //     if (rs.code == 200) {
      //       this.role = rs.data
      //     } else {
      //       this.role = []
      //     }
      //     if (this.role.length > 0) {
      //       if (this.$store.state.role_id == '' || this.$store.state.role_id == undefined) {
      //         this.$store.commit('setBindrole', {
      //           role_id: this.role[0].roleList[0].role_id,
      //           role_name: this.role[0].roleList[0].role_name,
      //           server_id: this.role[0].roleList[0].server_id,
      //           server_name: this.role[0].roleList[0].server_name
      //         })
      //       }
      //     }
      //   })
      // },
    },
    watch: {
      route_gameId: {
        immediate: true,
        handler(e) {
          if (e.route.name == 'home' && e.gameId && e.route.query.id != e.gameId) {
            this.$router.replace({
              name: 'home',
              query: Object.assign({}, e.route.query, {
                id: e.gameId
              })
            })
          }
        }
      },
      $route: {
        immediate: true,
        handler(e) {
          if (e.name == 'user.withdraw') {
            this.showqr = false
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  @import "../../assets/animate.css";

  .main_footer {
    background-color: var(--innerbgc);
  }

  .footer.van-tabbar {
    height: 7rem;
    width: 100%;
    max-width: 525px;
    z-index: 100;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    // background-color: #fff;

    background: url('../../assets/bx/footer.png') no-repeat 0 0 / 100% 100%;

    &.van-hairline--top-bottom::after,
    &.van-hairline-unset--top-bottom::after {
      border: none;
    }

    /deep/.van-tabbar-item {
      font-size: 1.2rem;
      width: 33.3%;
      flex: unset;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .van-tabbar-item__icon {
        // margin-left: 0.3rem;
        margin-bottom: 0.4rem;
      }

      .van-tabbar-item__text {
        color: #999;
        font-size: 1.2rem;
      }

      &.van-tabbar-item--active {
        background-color: transparent;
        .van-tabbar-item__text {
          color: var(--theme);
        }
      }

      &.index_tab {
        margin-top: 2.3rem;

        .van-tabbar-item__icon {
          width: 2.4rem;
          height: 2.4rem;
          background: url('../../assets/version_1.3.0/index/tab1.png') no-repeat 0 0 / 100% 100%;
        }

        &.van-tabbar-item--active {
          .van-tabbar-item__icon {
            background: url('../../assets/version_1.3.0/index/tab1_active.png') no-repeat 0 0 / 100% 100%;
          }
        }
      }

      &.dajin_tab {
        margin-top: 2.3rem;

        .van-tabbar-item__icon {
          width: 2rem;
          height: 2rem;
          background: url('../../assets/bx/tab2.png') no-repeat 0 0 / 100% 100%;
        }

        &.van-tabbar-item--active {
          .van-tabbar-item__icon {
            background: url('../../assets/bx/tab2_active.png') no-repeat 0 0 / 100% 100%;
          }
        }
      }

      &.home_tab {
        margin-top: 2.3rem;

        .van-tabbar-item__icon {
          width: 2rem;
          height: 2rem;
          background: url('../../assets/bx/tab3.png') no-repeat 0 0 / 100% 100%;
        }

        &.van-tabbar-item--active {
          .van-tabbar-item__icon {
            background: url('../../assets/bx/tab3_active.png') no-repeat 0 0 / 100% 100%;
          }
        }
      }

      &.my_tab {
        margin-top: 2.3rem;

        .van-tabbar-item__icon {
          width: 2.4rem;
          height: 2.4rem;
          background: url('../../assets/version_1.3.0/index/tab3.png') no-repeat 0 0 / 100% 100%;
        }

        &.van-tabbar-item--active {
          .van-tabbar-item__icon {
            background: url('../../assets/version_1.3.0/index/tab3_active.png') no-repeat 0 0 / 100% 100%;
          }
        }
      }

      &.footer_sell {
        margin-top: .8rem;

        .van-tabbar-item__icon {
          width: 2.9rem;
          height: 3.1rem;
          background: url('../../assets/version_1.3.0/index/tab2.png') no-repeat 0 0 / 100% 100%;
        }

        &.van-tabbar-item--active {
          .van-tabbar-item__icon {
            background: url('../../assets/version_1.3.0/index/tab2_active.png') no-repeat 0 0 / 100% 100%;
          }
        }
      }
    }
  }

  .jc {
    position: fixed;
    top: 0;
    left: 50%;
    width: 100%;
    max-width: 525px;
    height: 100%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.55);
    z-index: 1001;

    .step {
      width: 100%;
      height: 100%;
      position: relative;

      &.step1,
      &.step2,
      &.step3 {
        .next_button {
          position: absolute;
          left: 50%;
          top: 38rem;
          transform: translateX(-50%);
          width: 13rem;
          height: 3.5rem;
          border: 1px solid #fff;
          color: #fff;
          border-radius: 10rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.4rem;

          &:active {
            transform: translateX(-50%) scale(0.95);
            opacity: 0.9;
          }
        }
      }

      &.step1 {
        .cont {
          width: 22.3rem;
          height: 5.9rem;
          background: linear-gradient(180deg, #ffbea2 0%, #F66F30 100%);
          border-radius: 4.5rem 4.5rem 0px 4.5rem;
          padding-top: 1.1rem;
          padding-left: 2.5rem;
          font-size: 1.4rem;
          color: #fff;
          position: absolute;
          bottom: 16rem;
          left: 2.65rem;

          &::after {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: .8rem .9rem 0 .9rem;
            border-color: #F66F30 transparent transparent transparent;
            position: absolute;
            bottom: -.6rem;
            left: 15rem;
          }

          .tip_round {
            position: absolute;
            bottom: -2.5rem;
            left: 15.3rem;
            width: 1.3rem;
            height: 1.3rem;
            border-radius: 50%;
            background: linear-gradient(#F66F30 0%, #FBB08E 100%);

            &::after {
              content: '';
              width: .2rem;
              height: 4.4rem;
              background: linear-gradient(#FBB08E 0%, transparent 100%);
              position: absolute;
              top: 1.3rem;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }

        .img {
          position: fixed;
          bottom: 1rem;
          left: 50%;
          transform: translateX(-50%);
          width: 7.2rem;
          height: 7.2rem;
          border-radius: 50%;
          border: 1px solid #f66f30;
          font-size: 1.2rem;
          color: var(--theme);
          text-align: center;
          padding-top: 4.5rem;
          background: url(../../assets/version_1.3.0/index/tab2_active.png) no-repeat center 1.3rem/2.9rem 3.1rem;
          background-color: #ffece4;
        }
      }

      &.step2 {
        .cont {
          width: 19rem;
          height: 4.7rem;
          line-height: 4.7rem;
          text-align: center;
          background: linear-gradient(180deg, #F66F30 0%, #ffbea2 100%);
          border-radius: 10rem;
          font-size: 1.4rem;
          color: #fff;
          margin: 7.8rem auto 0;
          position: relative;
          &::after {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 .9rem .8rem .9rem;
            border-color:  transparent transparent #F66F30 transparent;
            position: absolute;
            top: -.8rem;
            left: 50%;
            transform:translateX(-50%);
          }

          .tip_round {
            position: absolute;
            top: -2.8rem;
            left: 50%;
            transform:translateX(-50%);
            width: 1.3rem;
            height: 1.3rem;
            border-radius: 50%;
            background: linear-gradient(#F66F30 0%, #FBB08E 100%);

            &::after {
              content: '';
              width: .2rem;
              height: 4.4rem;
              background: linear-gradient(transparent 0%, #FBB08E 100%);
              position: absolute;
              top: -4.4rem;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
        .next_button {
          position: static;
          left:unset;
          transform: unset;
          margin: 3.2rem auto 0;
          &:active {
            transform: scale(0.95);
            opacity: 0.9;
          }
        }
      }

      &.step3 {
        .next_button {
          top: unset !important;
          bottom: 32.5rem;
          right: 6rem;
          left: unset;
          transform:unset;
          &:active {
            transform: scale(0.95);
            opacity: 0.9;
          }
        }
        .cont {
          position: absolute;
          width: 22.5rem;
          height: 4.7rem;
          line-height: 4.7rem;
          background: linear-gradient(  #FBB08E 0%, #F66F30 100%);
          border-radius: 4.5rem 0px 4.5rem 4.5rem;
          text-align:center;
          font-size: 1.4rem;
          color: #fff;
          left: unset;
          right: 2rem;
          bottom: 26rem;
          &::after {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: .8rem .9rem 0 .9rem;
            border-color: #F66F30 transparent transparent transparent;
            position: absolute;
            bottom: -.7rem;
            right: 1.8rem;
          }
        }
        .tip_round {
          position: absolute;
          bottom: -2.5rem;
          right: 2rem;
          width: 1.3rem;
          height: 1.3rem;
          border-radius: 50%;
          background: linear-gradient(#F66F30 0%, #FBB08E 100%);
          &::after {
            content: '';
            width: .2rem;
            height: 4.4rem;
            background: linear-gradient(#FBB08E 0%, transparent 100%);
            position: absolute;
            top: 1.3rem;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .img {
          position: fixed;
          bottom: 11rem;
          left: calc(50% + 14rem);
          transform: translateX(-50%);
          width: 7.2rem;
          height: 7.2rem;
          border-radius: 50%;
          border: 1px solid #f66f30;
          color: var(--theme);
          text-align: center;
          background: url(../../assets/version_1.3.0/market/jssm.png) no-repeat center center/4rem 5.4rem;
          background-color: #ffece4;
        }
      }
    }
  }

  .qr_close {
    z-index: 100;
    position: fixed;
    top: 36rem;
    right: -2rem;
    width: 4rem;
    height: 4rem;
    background-color: rgba(153, 153, 153, 0.5);
    border-radius: 50%;
    cursor: pointer;

    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0.2rem;
      font-size: 2rem;
    }
  }

  .qr_open {
    z-index: 100;
    position: fixed;
    top: 32rem;
    right: -1.2rem;
    background-color: rgba(153, 153, 153, 0.3);
    width: 12rem;
    height: 12rem;
    border-top-left-radius: 1.6rem;
    border-bottom-left-radius: 1.6rem;
    color: var(--theme);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 0.4rem;

    &::before {
      content: "";
      position: absolute;
      left: -1.2rem;
      top: 50%;
      transform: translateY(-50%);
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      background: linear-gradient(to right, rgba(153, 153, 153, 0.3) 0%, rgba(153, 153, 153, 0.3) 30%, transparent 30.1%, transparent 100%);
      cursor: pointer;
    }

    .arrow {
      position: absolute;
      left: -1rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: 2rem;
      cursor: pointer;
    }

    .qrcode {
      width: 8rem;
      height: 8rem;
      background-color: #fff;
      margin-top: 1.2rem;
      margin-bottom: 0.5rem;

      /deep/img,
      /deep/canvas {
        width: 100%;
        height: 100%;
      }
    }

    a {
      color: var(--theme);
      font-size: 1.2rem;
    }
  }

  .game_box {
    display: flex;
    padding: 1.2rem 0.6rem;
    border-top: 1px solid #e9e9e9;
    background-color:#FFE4D8;
    border: 1px solid var(--theme);
    border-radius: 1.5rem;
    width: calc(100% - 1rem);
    max-width: calc(525px - 1rem);
    margin: 0 auto;
    .icon {
      width: 5.2rem;
      height: 5.2rem;
      border-radius: 1rem;
      overflow: hidden;
      margin-right: .8rem;
    }

    .info {
      flex: 1;
      padding: 0.4rem 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .name {
        font-size: 1.4rem;
        color: #000;
      }

      .num {
        display: flex;
        justify-content: space-between;
        color: #929292;
        font-size: 1.2rem;

        i {
          color: #FF5E5E;
        }
      }
    }

    .rz {
      margin-left: 2rem;
      padding-bottom: .4rem;
      width: 7.8rem;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      font-size: 1.2rem;
      color: #929292;

      .rz_icon {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: .5rem;
        transform: translateY(-0.2rem);
      }

      .bl {
        padding-left: 0.5rem;
        margin-left: 0.5rem;
        position: relative;

        &::before {
          content: '';
          width: 1px;
          height: 1.2rem;
          background-color: #929292;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }


</style>